/**
 * Tâche 1298 (Eric 2026-09-24) — Bandeau d'environnement.
 *
 * La préproduction et la production se ressemblent au pixel près. On a déjà
 * coupé la diarisation en production en croyant agir sur un bac à sable, et
 * Vincent a cherché son accès pendant des semaines sur le mauvais domaine.
 * Le bandeau rend l'environnement impossible à confondre : il est visible en
 * permanence, sur toutes les pages, y compris l'écran de connexion.
 *
 * Signal retenu : le NOM DE DOMAINE servi au navigateur. C'est le seul fait
 * que l'utilisateur voit, et il ne dépend d'aucun appel réseau qui pourrait
 * échouer précisément quand on a besoin de savoir où on est.
 */
import { useEffect, useState } from "react";
import { Warning } from "@phosphor-icons/react";

import { useLang } from "../contexts/LanguageContext";

const HOTES_PRODUCTION = ["knoria.com", "www.knoria.com"];

export const isProductionHost = (hostname) => HOTES_PRODUCTION.includes((hostname || "").toLowerCase());

export default function EnvironmentBanner() {
  const { tr } = useLang();
  const [reduit, setReduit] = useState(false);
  const hostname = typeof window === "undefined" ? "" : window.location.hostname;
  const production = isProductionHost(hostname);

  // L'onglet aussi doit trahir l'environnement : c'est là qu'on se trompe,
  // avec deux onglets Knoria côte à côte.
  useEffect(() => {
    if (production || typeof document === "undefined") return;
    const prefixe = "[PRÉPROD] ";
    if (!document.title.startsWith(prefixe)) document.title = prefixe + document.title;
  }, [production]);

  if (production) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[65] flex items-center gap-2 px-3 py-1 text-[11px] font-semibold tracking-wide text-amber-950 border-t border-amber-500 shadow-[0_-2px_8px_rgba(0,0,0,0.12)]"
      style={{
        backgroundImage:
          "repeating-linear-gradient(135deg, #fde68a 0 12px, #fcd34d 12px 24px)",
        paddingRight: "12rem",
      }}
      data-testid="env-banner"
    >
      <Warning size={14} weight="fill" className="flex-shrink-0 text-amber-800" />
      <span data-testid="env-banner-label">{tr("PRÉPRODUCTION", "PREVIEW")}</span>
      {!reduit && (
        <span className="font-normal opacity-90 truncate" data-testid="env-banner-detail">
          {tr("— base de données et données de test distinctes de la production. Rien de ce qui est fait ici n'atteint knoria.com.",
              "— database and test data separate from production. Nothing done here reaches knoria.com.")}
        </span>
      )}
      <button
        type="button"
        onClick={() => setReduit((v) => !v)}
        className="ml-auto flex-shrink-0 underline decoration-dotted hover:no-underline"
        data-testid="env-banner-toggle"
      >
        {reduit ? tr("détails", "details") : tr("réduire", "collapse")}
      </button>
    </div>
  );
}
